import React, { ReactNode } from 'react';

import Button from 'components/core/Button';
import Modal from 'components/core/Modal';
import Text from 'components/core/Text';

type TConfirmModalProps = {
  isOpen: boolean;
  title: string;
  message: ReactNode;
  confirmLabel: string;
  confirmVariant?: 'primary' | 'danger';
  confirmDisabled?: boolean;
  cancelLabel?: string;
  onConfirm: () => void;
  onClose: () => void;
};

const ConfirmModal = ({
  isOpen,
  title,
  message,
  confirmLabel,
  confirmVariant = 'primary',
  confirmDisabled = false,
  cancelLabel = 'Cancel',
  onConfirm,
  onClose,
}: TConfirmModalProps) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title={title}
    width={440}
    footer={
      <>
        <Button variant="ghost" onClick={onClose}>
          {cancelLabel}
        </Button>
        <Button variant={confirmVariant} disabled={confirmDisabled} onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </>
    }>
    {typeof message === 'string' ? (
      <Text variant="body" color="textSecondary">
        {message}
      </Text>
    ) : (
      message
    )}
  </Modal>
);

export default ConfirmModal;
